import { useMutation, useQuery, useQueryClient } from 'react-query';

import { DefaultClass } from '../../models/DefaultClass';
import defaultClassService from '../../services/defaultClassService';

export const useDefaultClasses = () => {
  const { data, status } = useQuery('defaultClasses', () =>
    defaultClassService.getAll()
  );

  return {
    defaultClasses: data || [],
    status,
  };
};

export const useDefaultClassCreate = () => {
  const queryClient = useQueryClient();

  return useMutation<DefaultClass, Error, DefaultClass>(defaultClassService.create, {
    onSuccess: (data) => {
      queryClient.setQueryData<DefaultClass[]>(
        'defaultClasses',
        (classes: DefaultClass[] | undefined) => [...(classes || []), data]
      );
    },
  });
};

export const useDefaultClassUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation<DefaultClass, Error, DefaultClass>(defaultClassService.update, {
    onSuccess: (data) => {
      queryClient.setQueryData<DefaultClass[]>(
        'defaultClasses',
        (classes: DefaultClass[] | undefined) =>
          classes?.map((c) => (c.id === data.id ? data : c)) || []
      );
    },
  });
};

export const useDefaultClassRemove = () => {
  const queryClient = useQueryClient();

  return useMutation<DefaultClass, Error, DefaultClass>(defaultClassService.remove, {
    onSuccess: (data, variable) => {
      queryClient.setQueryData<DefaultClass[]>(
        'defaultClasses',
        (classes: DefaultClass[] | undefined) =>
          classes?.filter((c) => c.id !== variable.id) || []
      );
    },
  });
};
